import { useQuery } from '@tanstack/react-query';
import { dashboardApi, myDashboardApi } from '../services/workspaceApi';
import { useTasksDashboardFilters } from './useDashboardFilters';

export const dashboardKeys = {
  all: ['tasks-dashboard'] as const,
  data: () => [...dashboardKeys.all, 'data'] as const,
  myData: () => [...dashboardKeys.all, 'my-data'] as const,
};

export function useWorkManagementDashboard() {
  return useQuery({
    queryKey: dashboardKeys.data(),
    queryFn: dashboardApi.get,
    staleTime: 30 * 1000, // 30 seconds
  });
}

export function useMyDashboard(workspaceId?: string, scope?: 'my' | 'all') {
  return useQuery({
    queryKey: [...dashboardKeys.myData(), workspaceId ?? 'all', scope ?? 'my'],
    queryFn: () => myDashboardApi.get(workspaceId, scope),
    staleTime: 30 * 1000, // 30 seconds
  });
}

/**
 * The my-dashboard read scoped to the surrounding dashboard's filters.
 *
 * Every tasks widget calls this, so the whole grid shares one request via the
 * React Query cache. On the home dashboard (no filter provider) it resolves to
 * the personal, all-workspaces view.
 */
export function useTasksWidgetData() {
  const { workspaceId, scope } = useTasksDashboardFilters();
  return useMyDashboard(workspaceId, scope);
}
